import humanizeString from 'humanize-string'
import React, { FC } from 'react'

import { SelectBasedField } from '@new/__global/components/Filters/FiltersVariations/Select'

import { FiltersSharedProps } from './Filters.types'

interface ChartComparisonFilterProps extends FiltersSharedProps {
  initialValue?: string
  onChange: (value?: string) => void
}

export enum ChartsComparison {
  period = 'period',
  yearOverYear = 'yearOverYear',
}

const comparisonLabel = {
  [ChartsComparison.period]: 'Period',
  [ChartsComparison.yearOverYear]: 'YoY',
}

export const chartComparisonOptions = () =>
  Object.values(ChartsComparison).map(option => ({
    label: humanizeString(option),
    value: option,
    customInputLabel: comparisonLabel[option],
  }))

export const ChartComparisonFilter: FC<ChartComparisonFilterProps> = ({
  label,
  initialValue,
  onChange,
  isSidebarFilter,
}) => {
  const selectedValue = initialValue
    ? chartComparisonOptions().find(option => option.value === initialValue)?.value
    : undefined

  return (
    <SelectBasedField
      groupId="period-comparison-filter"
      title={label || 'Comparison'}
      inputTitle={label}
      options={chartComparisonOptions()}
      initialValue={selectedValue}
      onChange={onChange}
      isSidebarFilter={isSidebarFilter}
      inputWidth={130}
    />
  )
}
